import React, { useState, useEffect } from 'react';
import { Container, Paper, Typography, Box, Button, TextField, MenuItem, Select, FormControl, InputLabel, Alert } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import api from '../../services/api';
import BSDateInput from '../common/BSDateInput';
import { getCurrentBSDate } from '../../utils/dateUtils';

const karatOptions = ['22K', '24K', '22/22K', '24/24K', '18K', 'PT95', 'WG'];

const ShopMetalIssue = () => {
  const [karigar, setKarigar] = useState('');
  const [karigars, setKarigars] = useState([]);
  const [karat, setKarat] = useState('22K');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(() => getCurrentBSDate());
  const [remarks, setRemarks] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchKarigars = async () => {
      try {
        const res = await api.get('/api/karigar');
        setKarigars(res.data);
      } catch {}
    };
    fetchKarigars();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!karigar || !karat || !amount) {
      setError('Please select karigar, karat, and enter amount.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/karigar/metal-issue', {
        karigarAbbreviation: karigar,
        karat,
        amount,
        date,
        remarks,
        module: 'shop'
      });
      setSuccess('Metal issued successfully!');
      setAmount('');
      setRemarks('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to issue metal');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary">Back</Button>
        </Box>
        <Typography variant="h4" gutterBottom color="primary">
          Shop Metal Issue
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth required sx={{ mb: 2 }}>
            <InputLabel>Karigar</InputLabel>
            <Select value={karigar} label="Karigar" onChange={e => setKarigar(e.target.value)}>
              {karigars.map(k => (
                <MenuItem key={k.abbreviation} value={k.abbreviation}>{k.abbreviation} - {k.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth required sx={{ mb: 2 }}>
            <InputLabel>Karat</InputLabel>
            <Select value={karat} label="Karat" onChange={e => setKarat(e.target.value)}>
              {karatOptions.map(k => (
                <MenuItem key={k} value={k}>{k}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Amount (gms)"
            type="number"
            value={amount}
            onChange={e => setAmount(e.target.value)}
            required
            fullWidth
            sx={{ mb: 2 }}
            inputProps={{ min: 0, step: 'any' }}
          />
          <BSDateInput
            label="Date"
            value={date}
            onChange={(date) => setDate(date)}
            required
          />
          <TextField
            label="Remarks"
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
            fullWidth
            multiline
            minRows={2}
            sx={{ mb: 2 }}
          />
          <Box sx={{ mt: 3 }}>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? 'Issuing...' : 'Issue Metal'}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default ShopMetalIssue; 